import  gql  from 'graphql-tag'

export const REFRESH_TOKEN = gql`mutation refreshToken($input: RefreshInput!){
    refreshToken(input: $input){
        token
    }
}`;